<label class="vc-theme-toggle">
    <input
        type="checkbox"
        [attr.aria-labelledby]="labelId"
        [attr.aria-checked]="checked"
        [(ngModel)]="checked"
        (ngModelChange)="modeChanged.emit(checked ? 'dark' : 'light')" />
    @if (checked) {
        <vc-icon aria-hidden="true" name="light_mode" [tooltip]="'CORE.THEME.LIGHT' | transloco"></vc-icon>
    } @else {
        <vc-icon aria-hidden="true" name="dark_mode" [tooltip]="'CORE.THEME.DARK' | transloco"></vc-icon>
    }
    <span [hidden]="true" [id]="labelId">Change theme to {{ checked ? 'dark' : 'light' }}</span>
</label>
